// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"407d0b52","387":"dbfea83a","455":"4e1754dd","734":"bb7c3d7e","857":"4edc7971","977":"c7b0e025"}[chunkId] + ".chunk.js";
};